import React from "react";
import { LAYOUT_VARIANTS } from "../config/appConfig";
import ArtworkCard from "./ArtworkCard";

// The reusable KEEP ONE comparison frame. DUEL and SHOWDOWN are presentation
// variants of the SAME primitive — not separate architectures.

function OrDivider({ axis }) {
  // axis: 'x' (duel, vertical bar between) | 'y' (showdown, horizontal band)
  return (
    <div
      aria-hidden
      className={
        axis === "x"
          ? "relative flex items-center justify-center w-6 shrink-0 self-stretch"
          : "relative flex items-center justify-center h-8 w-full"
      }
    >
      <div
        className={
          axis === "x"
            ? "absolute inset-y-6 w-px bg-white/10"
            : "absolute inset-x-10 h-px bg-white/10"
        }
      />
      <span className="relative z-10 font-mono text-[10px] font-bold tracking-[0.25em] text-white/45 bg-canvas px-1.5 py-0.5 rounded">
        OR
      </span>
    </div>
  );
}

export default function KeepOneArena({
  round,
  variant,
  chosenSide,
  onChoose,
  reducedMotion,
  ariaVerb,
  badgeLabel,
}) {
  const stateFor = (side) => {
    if (!chosenSide || chosenSide === "unknown") return "active";
    return chosenSide === side ? "chosen" : "losing";
  };
  const disabled = !!chosenSide;

  if (variant === LAYOUT_VARIANTS.SHOWDOWN) {
    return (
      <div className="flex flex-col h-full w-full gap-0" data-testid="arena-showdown">
        <div className="flex-1 min-h-0">
          <ArtworkCard
            work={round.left}
            side="left"
            orientation="wide"
            state={stateFor("left")}
            onChoose={onChoose}
            disabled={disabled}
            reducedMotion={reducedMotion}
            ariaVerb={ariaVerb}
            badgeLabel={badgeLabel}
            testId="artwork-left"
          />
        </div>
        <OrDivider axis="y" />
        <div className="flex-1 min-h-0">
          <ArtworkCard
            work={round.right}
            side="right"
            orientation="wide"
            state={stateFor("right")}
            onChoose={onChoose}
            disabled={disabled}
            reducedMotion={reducedMotion}
            ariaVerb={ariaVerb}
            badgeLabel={badgeLabel}
            testId="artwork-right"
          />
        </div>
      </div>
    );
  }

  // DUEL (default) — two poster-first cards side by side, centred on the stage.
  return (
    <div className="flex h-full w-full items-center justify-center" data-testid="arena-duel">
      <div className="flex-1 min-w-0">
        <ArtworkCard
          work={round.left}
          side="left"
          orientation="portrait"
          state={stateFor("left")}
          onChoose={onChoose}
          disabled={disabled}
          reducedMotion={reducedMotion}
          ariaVerb={ariaVerb}
          badgeLabel={badgeLabel}
          testId="artwork-left"
        />
      </div>
      <OrDivider axis="x" />
      <div className="flex-1 min-w-0">
        <ArtworkCard
          work={round.right}
          side="right"
          orientation="portrait"
          state={stateFor("right")}
          onChoose={onChoose}
          disabled={disabled}
          reducedMotion={reducedMotion}
          ariaVerb={ariaVerb}
          badgeLabel={badgeLabel}
          testId="artwork-right"
        />
      </div>
    </div>
  );
}
